var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210C165.228 210 210 165.228 210 110C210 54.7715 165.228 10 110 10C54.7715 10 10 54.7715 10 110C10 165.228 54.7715 210 110 210ZM110 159C137.614 159 160 136.614 160 109C160 81.3858 137.614 59 110 59C82.3858 59 60 81.3858 60 109C60 136.614 82.3858 159 110 159Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 109,
    r: 50,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Cm);
export default __webpack_public_path__ + "static/media/5cm.e291a2047b344f98027114f18ed66d35.svg";
export { ForwardRef as ReactComponent };